module.exports = __webpack_public_path__ + "resources/img/img_spiceware_pii_anp_01_kor.e5364771a6450289ede45f0094ab674b.png";